import React from "react";
import { IoIosClose } from 'react-icons/io'

function Modal({ open, handleClose, disableBackgroundClose = false, closeButton = true, maxWidth = "sm:max-w-xl", children }) {
    return (
        <div
            id="modal-component"
            onClick={disableBackgroundClose ? null : handleClose}
            className={`
                        fixed inset-0 flex z-50 justify-center items-center transition-colors bg-[rgba(0,0,0,0.5)]
                        ${open ? "visible" : "invisible"}
                    `}
        >
            <div
                className={`
                            px-4 py-6 sm:py-0 sm:pb-6 bg-[#fefefe] shadow-lg sm:rounded shadow-gray-950 w-full flex flex-col ${maxWidth} sm:h-auto mx-auto h-[100vh] overflow-y-auto sm:border transition-all duration-500 sm:duration-300 
                            ${open
                        ? "sm:scale-100 sm:opacity-100 translate-y-0"
                        : "sm:scale-0 sm:opacity-0 translate-y-full sm:translate-y-80"
                    }
                        `}
                onClick={(e) => e.stopPropagation()}
            >

                {/* Close Icon Button */}
                {
                    closeButton ?
                        <div className='flex justify-end'>
                            <label className='btn btn-ghost opacity-100 btn-square my-2 text-primary border' onClick={handleClose}>
                                <IoIosClose style={{ fontSize: '50px' }} />
                            </label>
                        </div>
                        :
                        <div className='flex justify-end'>
                            <label className='btn btn-ghost btn-disabled opacity-0 btn-square my-2 text-primary border' onClick={handleClose}>
                                <IoIosClose style={{ fontSize: '50px' }} />
                            </label>
                        </div>
                }

                {children}
            </div>
        </div>
    );
}

export default Modal;